import { IGPS, INetworkCoverage } from '@co-assist/library';

export enum Coverage {
    UNKNOWN = 'UNKNOWN',
    OK = 'OK',
    WEAK = 'WEAK',
    UNSUFFICIENT = 'UNSUFFICIENT',
    KO = 'KO'
}

export class NetworkCoverage implements INetworkCoverage {
    outdoor: Coverage;
    indoor: Coverage;
    address: string;
    gps?: IGPS;

    constructor(object?: any) {
        this.outdoor = object && object.outdoor || Coverage.UNKNOWN;
        this.indoor = object && object.indoor || Coverage.UNKNOWN;
        this.address = object && object.address || null;
        this.gps = object && object.gps || null;
    }
}
